/* eslint-disable */
const getters = {
  getGroup(state) {
    return state.data;
  },
  getIsLoading(state) {
    return state.isLoading;
  },
};

export default getters;
